import React, {useState} from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectUid} from '../../slices/auth';
import {addSubmission} from '../../api/submission';
import Button from '../Common/Button';
import {selectUser} from '../../slices/profile';

export const GameSubmissionNoProject = ({game}) => {
    const {register, handleSubmit, errors} = useForm({});
    const [loading, setLoading] = useState(false);
    const uid = useSelector(selectUid);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSubmit = form => {
        setLoading(true);

        const sub = {
            studentId: uid,
            created: new Date(),
            gameId: game.id,
            rmId: game.rmId,
            companyId: game.companyId,
            review: form.review
        };

        addSubmission(sub).then(() => {
            dispatch(openAlert({type: "success", message: t("alert_subNoProject_sent")}));
            dispatch(closeDialog());
            setLoading(false);
        })
            .catch(error => {
                console.error(error)
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
                dispatch(closeDialog());
                setLoading(false);
            })
    }

    return (
        <div className="gameSubmissionNoProject">
            <form onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={loading}>
                    <div className="element">
                        <div className="label">{t("student_submissionNoProject_review_label")}</div>
                        <textarea placeholder={t("student_submissionNoProject_review_ph")} rows={10} name="review"
                                  ref={register({required: true})}/>
                        {errors.review &&
                            <span className="error">{t("student_submissionNoProject_review_error")}</span>}
                    </div>
                    <Button type="submit" loading={loading}>{t("student_submissionNoProject_submit")}</Button>
                </fieldset>
            </form>
        </div>
    )
}
